import React from 'react';
import PropTypes from 'prop-types';
import * as Routes from 'modules/routes';
import Icon from '@/components/ui/Icon';
import { EditNewSlideShowButton } from '@/components/shared/LessonOverview/Cards/ActionBar/Buttons';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import cn from '@/utils/cn';
import useFlags from '@/hooks/useFlags';
import styles from '../../Navigator.module.scss';

const SlideShowEditButton = ({ parentId, parentType, position, programId, slideShow, slideShowId }) => {
  const userId = useSlideShowContext(state => state.userId);
  const userType = useSlideShowContext(state => state.userType);
  const { teacherPacedMode } = useFlags();

  const builderPath = () => {
    switch (userType) {
      case 'Sysadmin':
      case 'SupportManager':
      case 'ContentManager':
        return Routes.builder_admin_slide_show_path(slideShowId, {
          parent_id: parentId, parent_type: parentType, position, program_id: programId,
        });
      case 'Admin':
      case 'Coordinator':
      case 'Teacher':
        return Routes.builder_shared_slide_show_path(slideShowId, {
          parent_id: parentId, parent_type: parentType, position, program_id: programId,
        });
      default:
        return '';
    }
  };

  if (['Teacher', 'Admin', 'Coordinator'].includes(userType) && userId !== slideShow.staffer_id) {
    // AIDEV-NOTE: Unit slideshows can't be cloned (clone endpoints 500 on nil lesson) — hide Edit (PLAT-16018).
    if (parentType === 'Unit') return null;

    return (
      <EditNewSlideShowButton
        fromSlideShow
        useNewBuilder
        lessonId={parentId}
        programId={programId}
        slideShow={{
          ...slideShow,
          className: 'slide_show',
          links: {
            editPath: Routes.edit_shared_program_lesson_slide_show_path(programId, parentId, slideShowId, position),
          },
          slideShowId,
          title: slideShow.title_en,
          useNewBuilder: slideShow.use_new_builder,
        }}
        useButtonWithTooltip={false}
      />
    );
  }

  return (
    <a
      aria-label="Edit Slideshow"
      className={cn(styles.settingsMenuRow, teacherPacedMode ? styles.teacherPacedUpdates : styles.legacy)}
      href={builderPath()}
    >
      <span className={styles.menuIconButton}>
        <Icon icon="EditPreview" size={16} />
      </span>
      <div>Edit Slideshow</div>
    </a>
  );
};

export const SlideShowEditButtonPropTypes = PropTypes.shape({
  parentId: PropTypes.string.isRequired,
  parentType: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  programId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  slideShowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
});

SlideShowEditButton.propTypes = SlideShowEditButtonPropTypes.isRequired;

export default SlideShowEditButton;
